import { ReactNode, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "@nextui-org/react";
import { useRoles } from "../../hooks/useRoles";
import { useNotification } from "../../context/NotificationContext";

type EventAdminRouteProps = {
  children: ReactNode;
};

const EventAdminRoute = ({ children }: EventAdminRouteProps) => {
  const { hasEventAdminRole, isLoading } = useRoles();
  const { setNotification } = useNotification();

  useEffect(() => {
    if (!isLoading && !hasEventAdminRole()) {
      setNotification({
        type: "error",
        message: "You are not authorized to access CGI Events.",
      });
    }
  }, [isLoading, hasEventAdminRole, setNotification]);

  if (isLoading) {
    return (
      <div className="centered-loading">
        <Spinner size="lg" label="Checking permissions..." />
      </div>
    );
  }

  if (!hasEventAdminRole()) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default EventAdminRoute;